module.exports = __webpack_public_path__ + "static/media/summit-register-facial-success.d04099af.svg";